// Authorization header utility to include token with API requests
export default function authHeader() {
  const token = localStorage.getItem('token');
  
  if (token) {
    return { 
      'Authorization': `Token ${token}`,
      'Content-Type': 'application/json'
    };
  } else {
    return { 'Content-Type': 'application/json' };
  }
}
